import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const ProgressContainer = styled(motion.div)`
  position: fixed;
  top: 40px;
  right: 40px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 100;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

const ProgressDot = styled(motion.div)`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: white;
  opacity: 0.5;
  cursor: pointer;
`;

const ScrollProgress = ({ sections = ["hero", "how-it-works", "benefits", "social-proof", "cta"] }) => {
  const [activeSection, setActiveSection] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      
      const sectionIndex = Math.floor(scrollPosition / windowHeight);
      setActiveSection(sectionIndex);
    };
    
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  const scrollToSection = (index) => {
    window.scrollTo({
      top: index * window.innerHeight,
      behavior: 'smooth'
    });
  };
  
  return (
    <ProgressContainer>
      {sections.map((section, index) => (
        <ProgressDot
          key={index}
          animate={{
            scale: activeSection === index ? 1.5 : 1,
            opacity: activeSection === index ? 1 : 0.5,
            backgroundColor: activeSection === index ? 'var(--primary-color)' : 'white'
          }}
          onClick={() => scrollToSection(index)}
          whileHover={{ scale: 1.3, opacity: 0.8 }}
          whileTap={{ scale: 0.9 }}
        />
      ))}
    </ProgressContainer>
  );
};

export default ScrollProgress; 